import React from 'react';

const logins = [
  {
    id: 1,
    location: '📍 Chennai, India',
    device: 'Chrome (Windows)',
    time: 'Today, 9:42 AM',
    status: 'Success',
  },
  {
    id: 2,
    location: '📍 Bangalore, India',
    device: 'Safari (iPhone)',
    time: 'Yesterday, 7:10 PM',
    status: 'Success',
  },
  {
    id: 3,
    location: '📍 Unknown',
    device: 'Edge (Windows)',
    time: 'May 20, 2025, 3:14 AM',
    status: 'Failed',
  },
];

export default function SecurityActivityBox() {
  return (
    <div className="bg-white shadow rounded-lg p-4 mb-6">
      <h3 className="text-sm font-semibold text-gray-800 mb-3">🔐 Security & Login Activity</h3>
      <ul className="space-y-3 text-sm text-gray-700">
        {logins.map((log) => (
          <li
            key={log.id}
            className={`p-3 rounded border-l-4 ${
              log.status === 'Failed'
                ? 'bg-red-50 border-red-500'
                : 'bg-green-50 border-green-400'
            }`}
          >
            <div className="font-semibold">{log.location}</div>
            <div className="text-xs text-gray-600">
              {log.device} • {log.time} • {log.status}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
